import React from 'react';
import { Lightbulb, Wrench, XCircle, UserX } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const problems = [{
    icon: <Wrench className="w-6 h-6 text-[#D4A373]" data-id="element-223" />,
    title: 'They do one thing halfway',
    desc: "They mow lawns. They throw down some mulch. Maybe they pour a basic concrete slab if you push them. But they don't think about your property as a whole."
  }, {
    icon: <XCircle className="w-6 h-6 text-[#D4A373]" data-id="element-224" />,
    title: "They don't care about the final look",
    desc: "They don't care what it looks like when they leave. They don't ask what you actually want."
  }, {
    icon: <UserX className="w-6 h-6 text-[#D4A373]" data-id="element-225" />,
    title: 'They disappear when needed',
    desc: "And when something goes wrong? They're suddenly very hard to reach."
  }];
  return <section className="py-20 bg-[#FEFAE0]" data-id="element-226">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-228">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-229">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1B4332]/10 text-[#1B4332] mb-6 font-medium" data-id="element-230">
              <Lightbulb size={18} data-id="element-231" />
              <span data-id="element-232">The Industry Standard</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6 leading-tight" data-id="element-233">
              Here's What's <span className="text-[#1B4332]" data-id="element-234">Actually</span>{' '}
              Going On
            </h2>

            <p className="text-lg text-gray-700 mb-8" data-id="element-235">
              Most landscaping companies in this area do ONE thing — and do it
              halfway. That's not landscaping.{' '}
              <strong className="text-red-700" data-id="element-236">That's a disservice.</strong>
            </p>

            <div className="space-y-6" data-id="element-237">
              {problems.map((problem, idx) => <div key={idx} className="flex gap-4" data-id="element-238">
                  <div className="flex-shrink-0 mt-1" data-id="element-239">
                    <div className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center border border-gray-100" data-id="element-240">
                      {problem.icon}
                    </div>
                  </div>
                  <div data-id="element-241">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-242">
                      {problem.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-243">{problem.desc}</p>
                  </div>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#1B4332] text-white p-8 md:p-12 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-244">
            {/* Decorative background element */}
            <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 rounded-full bg-white/5 blur-3xl" data-id="element-245"></div>

            <h3 className="text-2xl font-serif font-bold mb-6 relative z-10" data-id="element-246">
              What your home actually needs...
            </h3>

            <p className="text-lg text-white/90 leading-relaxed mb-8 relative z-10" data-id="element-247">
              ...is a team that treats your property like it's their own. A crew
              that shows up on time, communicates clearly, does quality work —
              and doesn't stop until you are proud of what you see.
            </p>

            <div className="pt-8 border-t border-white/20 relative z-10" data-id="element-248">
              <p className="text-xl font-medium text-[#D4A373]" data-id="element-249">
                That's exactly what I&A Landscaping LLC was built to do.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}